import { type IconNames } from '@petsmart-ui/sparky';
import { VetRxCats, type VetRxInfo } from '@app/pdp/types';

export const getVetRxData = (cat: VetRxCats): VetRxInfo => {
    switch (cat) {
        case VetRxCats.COLD:
            return { text: 'Cold item', icon: 'circle-snowflake' };
        case VetRxCats.RX:
            return { text: 'Prescription item', icon: 'circle-rx' };
        case VetRxCats.VET:
            return { text: 'Vet diet item', icon: 'circle-plus' };
        default:
            return { text: '', icon: 'none' };
    }
};

export const getIcon = (cat: VetRxCats): IconNames => {
    switch (cat) {
        case VetRxCats.COLD:
            return 'circle-snowflake';
        case VetRxCats.RX:
            return 'circle-rx';
        case VetRxCats.VET:
            return 'circle-plus';
        default:
            return 'none';
    }
};

export const getText = (cat: VetRxCats): string => {
    switch (cat) {
        case VetRxCats.COLD:
            return 'Cold item separate purchase necessary';
        case VetRxCats.RX:
            return 'Prescription info required';
        case VetRxCats.VET:
            return 'Vet authorization required';
        default:
            return '';
    }
};

export const getDrawerHeader = (cat: VetRxCats | null): string => {
    switch (cat) {
        case VetRxCats.COLD:
            return 'Cold item info';
        case VetRxCats.RX:
            return 'Prescription info required';
        case VetRxCats.VET:
            return 'Vet authorization required';
        default:
            return '';
    }
};
